import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import {
  AdminEmployeeActiveList,
  GetDirectorOverallPerformanceReport,
  GetDirectorReportEmployee, HodEmployeeActiveList
} from "../../Repository/Api";
import { NonEmptyValidation } from "../../Store/validate";
import { FinancialMonthOptions, FinancialYearOptions, IsOldReportYear } from "../Common/FinancialYear";
import { errorMsg, successMsg } from "../Toastify";

const DirectorScoreReportGenerate = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const table1Ref = useRef(null);
  const table2Ref = useRef(null);
  const table3Ref = useRef(null);
  const table4Ref = useRef(null);
  const table5Ref = useRef(null);
  const table6Ref = useRef(null);

  const navigate = useNavigate();
  const { pathname } = useLocation()
  useEffect(() => {
    getEmployeeList();
  },[]);

  const initialApplyState = {
    employee_id: [],
    academic_year: [],
    months: [],
  };

  const [employee, setEmployee] = useState([]);
  const [apply, setApply] = useState(initialApplyState);
  const [validation, setValidation] = useState({});
  const [report, setReport] = useState({});
  
  const getEmployeeList = async () => {
    const response = pathname?.includes('Director') ? await GetDirectorReportEmployee(token) : pathname.includes('Hod') ? await HodEmployeeActiveList(token) : pathname?.includes('admin') && await AdminEmployeeActiveList(token)
    if (response && response.statusCode === 200) {
      let employee = pathname?.includes('Director') ?
        response?.data?.map((label) => ({
          label: label.name,
          value: label.id,
        })) :
        pathname?.includes('Hod') ?
          response?.data?.employee_details?.map((label) => ({
            label: label.first_name + ' ' + label.last_name,
            value: label.id,
          })) :
          pathname?.includes('admin') ?
            response?.data?.employee_details?.map((label) => ({
              label: label.first_name + ' ' + label.last_name,
              value: label.id,
            })) : ''
      setEmployee(employee);
    } else {
      errorMsg(response.message);
    }
  };
  const setData = (e, key) => {
    setApply({ ...apply, [key]: e });
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  let finalScore = report?.final_score || 0;
  let formattedScore = parseFloat(finalScore).toFixed(2);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let validate = {};

    validate.employee_id = NonEmptyValidation(apply?.employee_id);
    validate.academic_year = NonEmptyValidation(apply?.academic_year);
    if (!IsOldReportYear(apply)) {
      validate.months = NonEmptyValidation(apply?.months);
    }

    setValidation(validate);

    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        ...apply,
        employee_id: apply?.employee_id.value,
        months: apply?.months?.map((date) => date.value),
      };
      const response = await GetDirectorOverallPerformanceReport(
        Payload,
        token
      );
      if (response && response.statusCode === 200) {
        setReport(response.data);
        successMsg(response.message);
        setValidation({});
      } else {
        errorMsg(response.message);
      }
    }
  };
  const handleDownloadPdf = async () => {
    const pdf = new jsPDF();

    if (table1Ref.current) {
      const canvas1 = await html2canvas(table1Ref.current);
      const imgData1 = canvas1.toDataURL("image/png");

      // Get original dimensions
      const imgWidth1 = canvas1.width;
      const imgHeight1 = canvas1.height;

      // Calculate aspect ratio
      const pdfPageWidth = pdf.internal.pageSize.getWidth() - 20;
      const pdfPageHeight = pdf.internal.pageSize.getHeight() - 20;
      let newImgWidth1 = pdfPageWidth;
      let newImgHeight1 = (imgHeight1 * pdfPageWidth) / imgWidth1;

      // Adjust if height is too tall
      if (newImgHeight1 > pdfPageHeight) {
        newImgHeight1 = pdfPageHeight;
        newImgWidth1 = (imgWidth1 * pdfPageHeight) / imgHeight1;
      }

      pdf.addImage(
        imgData1,
        "PNG",
        10,
        10,
        newImgWidth1,
        newImgHeight1
      );
    }
    pdf.addPage();
    if (table2Ref.current) {
      const canvas1 = await html2canvas(table2Ref.current);
      const imgData1 = canvas1.toDataURL("image/png");

      // Get original dimensions
      const imgWidth1 = canvas1.width;
      const imgHeight1 = canvas1.height;

      // Calculate aspect ratio
      const pdfPageWidth = pdf.internal.pageSize.getWidth() - 20;
      const pdfPageHeight = pdf.internal.pageSize.getHeight() - 20;
      let newImgWidth1 = pdfPageWidth;
      let newImgHeight1 = (imgHeight1 * pdfPageWidth) / imgWidth1;

      // Adjust if height is too tall
      if (newImgHeight1 > pdfPageHeight) {
        newImgHeight1 = pdfPageHeight;
        newImgWidth1 = (imgWidth1 * pdfPageHeight) / imgHeight1;
      }

      pdf.addImage(
        imgData1,
        "PNG",
        10,
        10,
        newImgWidth1,
        newImgHeight1
      );
    }
    pdf.addPage();
    if (table3Ref.current) {
      const canvas1 = await html2canvas(table3Ref.current);
      const imgData1 = canvas1.toDataURL("image/png");

      // Get original dimensions
      const imgWidth1 = canvas1.width;
      const imgHeight1 = canvas1.height;

      // Calculate aspect ratio
      const pdfPageWidth = pdf.internal.pageSize.getWidth() - 20;
      const pdfPageHeight = pdf.internal.pageSize.getHeight() - 20;
      let newImgWidth1 = pdfPageWidth;
      let newImgHeight1 = (imgHeight1 * pdfPageWidth) / imgWidth1;

      // Adjust if height is too tall
      if (newImgHeight1 > pdfPageHeight) {
        newImgHeight1 = pdfPageHeight;
        newImgWidth1 = (imgWidth1 * pdfPageHeight) / imgHeight1;
      }

      pdf.addImage(
        imgData1,
        "PNG",
        10,
        10,
        newImgWidth1,
        newImgHeight1
      );
    }
    pdf.addPage();
    if (table4Ref.current) {
      const canvas1 = await html2canvas(table4Ref.current);
      const imgData1 = canvas1.toDataURL("image/png");

      // Get original dimensions
      const imgWidth1 = canvas1.width;
      const imgHeight1 = canvas1.height;

      // Calculate aspect ratio
      const pdfPageWidth = pdf.internal.pageSize.getWidth() - 20;
      const pdfPageHeight = pdf.internal.pageSize.getHeight() - 20;
      let newImgWidth1 = pdfPageWidth;
      let newImgHeight1 = (imgHeight1 * pdfPageWidth) / imgWidth1;

      // Adjust if height is too tall
      if (newImgHeight1 > pdfPageHeight) {
        newImgHeight1 = pdfPageHeight;
        newImgWidth1 = (imgWidth1 * pdfPageHeight) / imgHeight1;
      }

      pdf.addImage(
        imgData1,
        "PNG",
        10,
        10,
        newImgWidth1,
        newImgHeight1
      );
    }
    pdf.addPage();
    if (table5Ref.current) {
      const canvas1 = await html2canvas(table5Ref.current);
      const imgData1 = canvas1.toDataURL("image/png");

      // Get original dimensions
      const imgWidth1 = canvas1.width;
      const imgHeight1 = canvas1.height;

      // Calculate aspect ratio
      const pdfPageWidth = pdf.internal.pageSize.getWidth() - 20;
      const pdfPageHeight = pdf.internal.pageSize.getHeight() - 20;
      let newImgWidth1 = pdfPageWidth;
      let newImgHeight1 = (imgHeight1 * pdfPageWidth) / imgWidth1;

      // Adjust if height is too tall
      if (newImgHeight1 > pdfPageHeight) {
        newImgHeight1 = pdfPageHeight;
        newImgWidth1 = (imgWidth1 * pdfPageHeight) / imgHeight1;
      }

      pdf.addImage(
        imgData1,
        "PNG",
        10,
        10,
        newImgWidth1,
        newImgHeight1
      );
    }
    pdf.addPage();
    if (table6Ref.current) {
      const canvas1 = await html2canvas(table6Ref.current);
      const imgData1 = canvas1.toDataURL("image/png");

      // Get original dimensions
      const imgWidth1 = canvas1.width;
      const imgHeight1 = canvas1.height;

      // Calculate aspect ratio
      const pdfPageWidth = pdf.internal.pageSize.getWidth() - 20;
      const pdfPageHeight = pdf.internal.pageSize.getHeight() - 20;
      let newImgWidth1 = pdfPageWidth;
      let newImgHeight1 = (imgHeight1 * pdfPageWidth) / imgWidth1;

      // Adjust if height is too tall
      if (newImgHeight1 > pdfPageHeight) {
        newImgHeight1 = pdfPageHeight;
        newImgWidth1 = (imgWidth1 * pdfPageHeight) / imgHeight1;
      }

      pdf.addImage(
        imgData1,
        "PNG",
        10,
        10,
        newImgWidth1,
        newImgHeight1
      );
    }

    pdf.save(`${report?.name}_Performance_Report.pdf`);
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-4 my-auto">
                    <h6 className="labeltitle">
                      <span
                        className="arrowicon"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        ← &nbsp;
                      </span>
                      Overall Perfomance Report
                    </h6>
                  </div>
                </div>
                <div className="row mt-5">
                  <div className="col-lg-3">
                    <label className="labeltext"> Employee Name *</label>
                    <ReactSelect
                      isMulti={false}
                      value={apply?.employee_id}
                      onChange={(e) => {
                        setData(e, "employee_id");
                      }}
                      options={employee}
                    />
                    <small className="validationerror">
                      {validation?.employee_id?.message
                        ? `Employee ${validation?.employee_id?.message}`
                        : ""}
                    </small>
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext"> Academic Year *</label>
                    <ReactSelect
                      isMulti={false}
                      value={{
                        label: apply.academic_year,
                        value: apply.academic_year,
                      }}
                      onChange={(selectedOption) =>
                        setData(selectedOption.value, "academic_year")
                      }
                      // options={yearOptions}
                      options={FinancialYearOptions()}
                    />
                    <small className="validationerror">
                      {validation?.academic_year?.message
                        ? `Year ${validation?.academic_year?.message}`
                        : ""}
                    </small>
                  </div>
                  {!IsOldReportYear(apply) && (
                    <div className="col-lg-3">
                      <label className="labeltext"> Month *</label>
                      <ReactSelect
                        isMulti
                        value={apply?.months}
                        onChange={(e) => {
                          setData(e, "months");
                        }}
                        options={
                          apply?.months?.some((v) => v?.value === "all")
                            ? [{ label: "All", value: "all" }]
                            : FinancialMonthOptions(apply)
                        }
                      />
                      <small className="validationerror">
                        {validation?.months?.message
                          ? `Month ${validation?.months?.message}`
                          : ""}
                      </small>
                    </div>
                  )}
                  <div className="col-lg-3 centertext mt-5">
                    <button
                      type="submit"
                      className="requestbtn"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Get Report
                    </button>
                  </div>
                </div>
                <div>
                  <div ref={table1Ref}>
                    <h5 className="centertext my-5">
                      PERFORMANCE SCORE REPORT
                    </h5>
                    <div className="row mt-5">
                      <div className="col-lg-6 col-md-6">
                        <h6>1. Employee Name</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>{report?.name}</h6>
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6">
                        <h6>
                          2. Name of the Department / Centre / Extension Centre
                        </h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>{report?.department}</h6>
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6">
                        <h6>3. Current Designation</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>{report?.designation}</h6>
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6">
                        <h6>4. Academic Year</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>{report?.academic_year}</h6>
                      </div>
                    </div>

                    <div className="row my-4">
                      <div className="col-lg-6">
                        <h6>5. Month</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>{report?.month}</h6>
                      </div>
                    </div>
                    <div className="row my-4">
                      <div className="col-lg-6">
                        <h6>6. Total Score</h6>
                      </div>
                      <div className="col-lg-1 p-0">:</div>
                      <div className="col-lg-5">
                        <h6>{formattedScore}</h6>
                      </div>
                    </div>
                  </div>

                  <div ref={table2Ref}>
                    <h5 className="centertext my-5">ACADEMIC CONTRIBUTIONS</h5>
                    <table className="tablereport table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">Topic</th>
                          <th scope="col">Criteria</th>
                          <th scope="col">Target Fixed</th>
                          <th scope="col">Target Achieved</th>
                          <th scope="col">Score/Item</th>
                          <th scope="col">Score Fixed</th>
                          <th scope="col">Score Achieved</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="tablewidth">
                            a. Grant in aid Training Programmes conducted as
                            Coordinator Training programmes conducted for 3 days
                            as 0.5 equivalence and "n" weeks as "n" equivalence
                            of 5 days Conduct of number of 5 days training
                            programmes 20, 18 and 16 for Assistant Professor,
                            Associate Professor and Professor respectively.  Revenue Generated through Training Programmes as Co-ordinator
                          </td>
                          <td>
                            <tr>
                              <td>
                                Training Programmes conducted as Coordinator
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                Additional training programmes conducted as
                                Coordinator
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                &lt; 3 lakhs
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                3-5 lakhs
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                &gt; 5 lakhs
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.non_sponsored_training?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.non_sponsored_training?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.training_programmes_conducted
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.training_programmes_conducted
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_lt_3_lakhs
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_lt_3_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_3_t0_5_lakhs
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_3_t0_5_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_gt_5_lakhs
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_gt_5_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.non_sponsored_training?.total_activity
                                  ? report?.academic_contributions
                                    ?.non_sponsored_training?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.training_programmes_conducted
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.training_programmes_conducted
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_lt_3_lakhs
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_lt_3_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_3_t0_5_lakhs
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_3_t0_5_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_gt_5_lakhs
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_gt_5_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.non_sponsored_training?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.non_sponsored_training?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.training_programmes_conducted
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.training_programmes_conducted
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_lt_3_lakhs
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_lt_3_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_3_t0_5_lakhs
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_3_t0_5_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_gt_5_lakhs
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_gt_5_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.non_sponsored_training?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.non_sponsored_training?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.training_programmes_conducted
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.training_programmes_conducted
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_lt_3_lakhs
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_lt_3_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_3_t0_5_lakhs
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_3_t0_5_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_gt_5_lakhs
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_gt_5_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.non_sponsored_training?.total_score
                                  ? report?.academic_contributions
                                    ?.non_sponsored_training?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.training_programmes_conducted
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.training_programmes_conducted
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_lt_3_lakhs
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_lt_3_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_3_t0_5_lakhs
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_3_t0_5_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.aid_training_programmes_gt_5_lakhs
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.aid_training_programmes_gt_5_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            b. Sponsored Training Programmes
                            conducted as Coordinator/ Co-coordinator (Funded by State/ Central Government or ITEC)
                          </td>
                          <td>
                            <tr>
                              <td>
                                Training programmes conducted as Coordinator
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                Training programmes conducted as Co-coordinator
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.sponsored_contact_mode_for_coordinator_training
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.sponsored_contact_mode_for_coordinator_training
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.sponsored_contact_mode_for_co_coordinator_training
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.sponsored_contact_mode_for_co_coordinator_training
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.sponsored_contact_mode_for_coordinator_training
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.sponsored_contact_mode_for_coordinator_training
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.sponsored_contact_mode_for_co_coordinator_training
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.sponsored_contact_mode_for_co_coordinator_training
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.sponsored_contact_mode_for_coordinator_training
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.sponsored_contact_mode_for_coordinator_training
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.sponsored_contact_mode_for_co_coordinator_training
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.sponsored_contact_mode_for_co_coordinator_training
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.sponsored_contact_mode_for_coordinator_training
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.sponsored_contact_mode_for_coordinator_training
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.sponsored_contact_mode_for_co_coordinator_training
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.sponsored_contact_mode_for_co_coordinator_training
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.sponsored_contact_mode_for_coordinator_training
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.sponsored_contact_mode_for_coordinator_training
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.sponsored_contact_mode_for_co_coordinator_training
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.sponsored_contact_mode_for_co_coordinator_training
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            c. Skill Development/ Industrial Training Programmes
                            conducted as Coordinator/ Co-coordinator
                          </td>
                          <td>
                            <tr>
                              <td>
                                Training programmes conducted as Coordinator
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                Training programmes conducted as Co-coordinator
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.skill_development_for_coordinator_training
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.skill_development_for_coordinator_training
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.skill_development_for_co_coordinator_training
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.skill_development_for_co_coordinator_training
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.skill_development_for_coordinator_training
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.skill_development_for_coordinator_training
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.skill_development_for_co_coordinator_training
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.skill_development_for_co_coordinator_training
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.skill_development_for_coordinator_training
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.skill_development_for_coordinator_training
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.skill_development_for_co_coordinator_training
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.skill_development_for_co_coordinator_training
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.skill_development_for_coordinator_training
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.skill_development_for_coordinator_training
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.skill_development_for_co_coordinator_training
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.skill_development_for_co_coordinator_training
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.skill_development_for_coordinator_training
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.skill_development_for_coordinator_training
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.skill_development_for_co_coordinator_training
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.skill_development_for_co_coordinator_training
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            d. Development/ offer of MOOCs/ MMLPs as Coordinator/
                            Co-coordinator or minimum 30 min video lectures/
                            Educational video films
                          </td>
                          <td>
                            <tr>
                              <td>Offering of SWAYAM Course/ NITTT module</td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                Development of minimum 30 min video lecture/
                                Educational video films
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.development_for_minimum_30_min_video
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.development_for_minimum_30_min_video
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.development_for_minimum_30_min_video
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.development_for_minimum_30_min_video
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.development_for_minimum_30_min_video
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.development_for_minimum_30_min_video
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.development_for_minimum_30_min_video
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.development_for_minimum_30_min_video
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.development_of_moocs_offering_swayam_courses_or_nittt_module
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.development_for_minimum_30_min_video
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.development_for_minimum_30_min_video
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            e. Resource person in Training Programmes (Institute)
                          </td>
                          <td>For 18 hours</td>
                          <td>
                            {report?.academic_contributions
                              ?.resouce_program_in_training_programmes
                              ?.total_activity_fixed
                              ? report?.academic_contributions
                                ?.resouce_program_in_training_programmes
                                ?.total_activity_fixed
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.resouce_program_in_training_programmes
                              ?.total_activity
                              ? report?.academic_contributions
                                ?.resouce_program_in_training_programmes
                                ?.total_activity
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.resouce_program_in_training_programmes
                              ?.per_actitity_score
                              ? report?.academic_contributions
                                ?.resouce_program_in_training_programmes
                                ?.per_actitity_score
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.resouce_program_in_training_programmes
                              ?.total_score_fixed
                              ? report?.academic_contributions
                                ?.resouce_program_in_training_programmes
                                ?.total_score_fixed
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.resouce_program_in_training_programmes
                              ?.total_score
                              ? report?.academic_contributions
                                ?.resouce_program_in_training_programmes
                                ?.total_score
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            f. Development of Training/ Laboratory Manuals
                          </td>
                          <td>
                            Development of Training/ Laboratory Manuals
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.development_of_training_manual?.total_activity_fixed
                              ? report?.academic_contributions
                                ?.development_of_training_manual
                                ?.total_activity_fixed
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.development_of_training_manual?.total_activity
                              ? report?.academic_contributions
                                ?.development_of_training_manual
                                ?.total_activity
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.development_of_training_manual
                              ?.per_actitity_score
                              ? report?.academic_contributions
                                ?.development_of_training_manual
                                ?.per_actitity_score
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.development_of_training_manual?.total_score_fixed
                              ? report?.academic_contributions
                                ?.development_of_training_manual
                                ?.total_score_fixed
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.development_of_training_manual?.total_score
                              ? report?.academic_contributions
                                ?.development_of_training_manual?.total_score
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            g. Courses handled for PG/ Ph.D. programme
                          </td>
                          <td>
                            Classes handled individually for a 3 credit course/ semester
                            (If classes were conducted jointly, then the score will
                            be considered proportionately based on the number of faculty members involved)

                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.coursed_handled_for_pg_phd_programme
                              ?.total_activity_fixed
                              ? report?.academic_contributions
                                ?.coursed_handled_for_pg_phd_programme
                                ?.total_activity_fixed
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.coursed_handled_for_pg_phd_programme
                              ?.total_activity
                              ? report?.academic_contributions
                                ?.coursed_handled_for_pg_phd_programme
                                ?.total_activity
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.coursed_handled_for_pg_phd_programme
                              ?.per_actitity_score
                              ? report?.academic_contributions
                                ?.coursed_handled_for_pg_phd_programme
                                ?.per_actitity_score
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.coursed_handled_for_pg_phd_programme
                              ?.total_score_fixed
                              ? report?.academic_contributions
                                ?.coursed_handled_for_pg_phd_programme
                                ?.total_score_fixed
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.coursed_handled_for_pg_phd_programme
                              ?.total_score
                              ? report?.academic_contributions
                                ?.coursed_handled_for_pg_phd_programme
                                ?.total_score
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            h. New course(s) developed and offered
                          </td>
                          <td>3 credit course or its equivalent</td>
                          <td>
                            {report?.academic_contributions
                              ?.new_courses_developed_and_offered?.total_activity_fixed
                              ? report?.academic_contributions
                                ?.new_courses_developed_and_offered
                                ?.total_activity_fixed
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.new_courses_developed_and_offered
                              ?.total_activity
                              ? report?.academic_contributions
                                ?.new_courses_developed_and_offered
                                ?.total_activity
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.new_courses_developed_and_offered
                              ?.per_actitity_score
                              ? report?.academic_contributions
                                ?.new_courses_developed_and_offered
                                ?.per_actitity_score
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.new_courses_developed_and_offered?.total_score_fixed
                              ? report?.academic_contributions
                                ?.new_courses_developed_and_offered
                                ?.total_score_fixed
                              : "-"}
                          </td>
                          <td>
                            {report?.academic_contributions
                              ?.new_courses_developed_and_offered?.total_score
                              ? report?.academic_contributions
                                ?.new_courses_developed_and_offered
                                ?.total_score
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            i. Curriculum Developed/ Revised
                          </td>
                          <td>
                            <tr>
                              <td>&lt; 3 lakhs</td>
                            </tr>
                            <br />
                            <tr>
                              <td>3 - 5 lakhs</td>
                            </tr>
                            <br />
                            <tr>
                              <td>5 - 10 lakhs</td>
                            </tr>
                            <br />
                            <tr>
                              <td>10 - 15 lakhs</td>
                            </tr>
                            <br />
                            <tr>
                              <td>&gt; 15 lakhs</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_lt_3_lakhs
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_lt_3_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_3_to_5_lakhs
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_3_to_5_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_5_to_10_lakhs
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_5_to_10_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_10_to_15_lakhs
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_10_to_15_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_gt_15_lakhs
                                  ?.total_activity_fixed
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_gt_15_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_lt_3_lakhs
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_lt_3_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_3_to_5_lakhs
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_3_to_5_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_5_to_10_lakhs
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_5_to_10_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_10_to_15_lakhs
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_10_to_15_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_gt_15_lakhs
                                  ?.total_activity
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_gt_15_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_lt_3_lakhs
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_lt_3_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_3_to_5_lakhs
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_3_to_5_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_5_to_10_lakhs
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_5_to_10_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_10_to_15_lakhs
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_10_to_15_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_gt_15_lakhs
                                  ?.per_actitity_score
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_gt_15_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_lt_3_lakhs
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_lt_3_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_3_to_5_lakhs
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_3_to_5_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_5_to_10_lakhs
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_5_to_10_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_10_to_15_lakhs
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_10_to_15_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_gt_15_lakhs
                                  ?.total_score_fixed
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_gt_15_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_lt_3_lakhs
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_lt_3_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_3_to_5_lakhs
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_3_to_5_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_5_to_10_lakhs
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_5_to_10_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_10_to_15_lakhs
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_10_to_15_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.academic_contributions
                                  ?.curriculum_developed_revised_gt_15_lakhs
                                  ?.total_score
                                  ? report?.academic_contributions
                                    ?.curriculum_developed_revised_gt_15_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">Total</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            {report?.academic_contributions_total
                              ? report?.academic_contributions_total
                              : "-"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div ref={table3Ref}>
                    <h5 className="centertext my-5">RESEARCH CONTRIBUTIONS</h5>
                    <table className="tablereport table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">Topic</th>
                          <th scope="col">Criteria</th>
                          <th scope="col">Target Fixed</th>
                          <th scope="col">Target Achieved</th>
                          <th scope="col">Score/Item</th>
                          <th scope="col">Score Fixed</th>
                          <th scope="col">Score Achieved</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="tablewidth">
                            a. Ph.D. research scholars guided
                          </td>
                          <td>Degree awarded</td>
                          <td>
                            {report?.research_contributions
                              ?.phd_research_guidance?.total_activity_fixed
                              ? report?.research_contributions
                                ?.phd_research_guidance?.total_activity_fixed
                              : "-"}
                          </td>
                          <td>
                            {report?.research_contributions
                              ?.phd_research_guidance?.total_activity
                              ? report?.research_contributions
                                ?.phd_research_guidance?.total_activity
                              : "-"}
                          </td>
                          <td>
                            {report?.research_contributions
                              ?.phd_research_guidance?.per_actitity_score
                              ? report?.research_contributions
                                ?.phd_research_guidance?.per_actitity_score
                              : "-"}
                          </td>
                          <td>
                            {report?.research_contributions
                              ?.phd_research_guidance?.total_score_fixed
                              ? report?.research_contributions
                                ?.phd_research_guidance?.total_score_fixed
                              : "-"}
                          </td>
                          <td>
                            {report?.research_contributions
                              ?.phd_research_guidance?.total_score
                              ? report?.research_contributions
                                ?.phd_research_guidance?.total_score
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            b. Post Graduate thesis guided
                          </td>
                          <td>Degree awarded</td>
                          <td>
                            {report?.research_contributions
                              ?.post_graduate_thesis_guidance?.total_activity_fixed
                              ? report?.research_contributions
                                ?.post_graduate_thesis_guidance
                                ?.total_activity_fixed
                              : "-"}
                          </td>
                          <td>
                            {report?.research_contributions
                              ?.post_graduate_thesis_guidance?.total_activity
                              ? report?.research_contributions
                                ?.post_graduate_thesis_guidance
                                ?.total_activity
                              : "-"}
                          </td>
                          <td>
                            {report?.research_contributions
                              ?.post_graduate_thesis_guidance
                              ?.per_actitity_score
                              ? report?.research_contributions
                                ?.post_graduate_thesis_guidance
                                ?.per_actitity_score
                              : "-"}
                          </td>
                          <td>
                            {report?.research_contributions
                              ?.post_graduate_thesis_guidance?.total_score_fixed
                              ? report?.research_contributions
                                ?.post_graduate_thesis_guidance
                                ?.total_score_fixed
                              : "-"}
                          </td>
                          <td>
                            {report?.research_contributions
                              ?.post_graduate_thesis_guidance?.total_score
                              ? report?.research_contributions
                                ?.post_graduate_thesis_guidance?.total_score
                              : "-"}
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            c. Sponsored research projects carried out
                          </td>
                          <td>
                            <tr>
                              <td>Submitted</td>
                            </tr>
                            <br />
                            <tr>
                              <td>&lt; 5 lakhs</td>
                            </tr>
                            <br />
                            <tr>
                              <td>5 - 15 lakhs</td>
                            </tr>
                            <br />
                            <tr>
                              <td>&gt; 15 lakhs</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_submitted
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_submitted
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_lt_5_lakhs
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_lt_5_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_5_to_15_lakhs
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_5_to_15_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_gt_15_lakhs
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_gt_15_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_submitted
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_submitted
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_lt_5_lakhs
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_lt_5_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_5_to_15_lakhs
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_5_to_15_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_gt_15_lakhs
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_gt_15_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_submitted
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_submitted
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_lt_5_lakhs
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_lt_5_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_5_to_15_lakhs
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_5_to_15_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_gt_15_lakhs
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_gt_15_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_submitted
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_submitted
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_lt_5_lakhs
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_lt_5_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_5_to_15_lakhs
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_5_to_15_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_gt_15_lakhs
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_gt_15_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_submitted
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_submitted
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_lt_5_lakhs
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_lt_5_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_5_to_15_lakhs
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_5_to_15_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.sponsored_research_projects_gt_15_lakhs
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.sponsored_research_projects_gt_15_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            d. Consultancy works carried out based on the requirements of the Clientele system.
                          </td>
                          <td>
                            <tr>
                              <td>&lt; 3 lakhs</td>
                            </tr>
                            <br />
                            <tr>
                              <td>3 - 5 lakhs</td>
                            </tr>
                            <br />
                            <tr>
                              <td>&gt; 5 lakhs</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_lt_3_lakhs
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_lt_3_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_3_to_5_lakhs
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_3_to_5_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_gt_5_lakhs
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_gt_5_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_lt_3_lakhs
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_lt_3_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_3_to_5_lakhs
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_3_to_5_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_gt_5_lakhs
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_gt_5_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_lt_3_lakhs
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_lt_3_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_3_to_5_lakhs
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_3_to_5_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_gt_5_lakhs
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_gt_5_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_lt_3_lakhs
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_lt_3_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_3_to_5_lakhs
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_3_to_5_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_gt_5_lakhs
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_gt_5_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_lt_3_lakhs
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_lt_3_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_3_to_5_lakhs
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_3_to_5_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.consultancy_works_carried_out_gt_5_lakhs
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.consultancy_works_carried_out_gt_5_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            e. Research publications in referred
                            journals only as first/ corresponding
                            author (For more than one author, the
                            score for other authors will be 50%)
                          </td>
                          <td>
                            <tr>
                              <td>SCI</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Scopus indexed</td>
                            </tr>
                            <br />
                            <tr>
                              <td>UGC listed</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_sci?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.research_publications_in_sci
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_scopus_indexed
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.research_publications_in_scopus_indexed
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_ugc_listed
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.research_publications_in_ugc_listed
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_sci?.total_activity
                                  ? report?.research_contributions
                                    ?.research_publications_in_sci
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_scopus_indexed
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.research_publications_in_scopus_indexed
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_ugc_listed
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.research_publications_in_ugc_listed
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_sci
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.research_publications_in_sci
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_scopus_indexed
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.research_publications_in_scopus_indexed
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_ugc_listed
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.research_publications_in_ugc_listed
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_sci?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.research_publications_in_sci
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_scopus_indexed
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.research_publications_in_scopus_indexed
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_ugc_listed
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.research_publications_in_ugc_listed
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_sci?.total_score
                                  ? report?.research_contributions
                                    ?.research_publications_in_sci
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_scopus_indexed
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.research_publications_in_scopus_indexed
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.research_publications_in_ugc_listed
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.research_publications_in_ugc_listed
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            f. Papers presented in national/ international
                            conference/ seminar
                          </td>
                          <td>
                            <tr>
                              <td>International</td>
                            </tr>
                            <br />
                            <tr>
                              <td>National</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.paper_presented_in_international
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.paper_presented_in_international
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.paper_presented_in_national?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.paper_presented_in_national?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.paper_presented_in_international
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.paper_presented_in_international
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.paper_presented_in_national?.total_activity
                                  ? report?.research_contributions
                                    ?.paper_presented_in_national
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.paper_presented_in_international
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.paper_presented_in_international
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.paper_presented_in_national
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.paper_presented_in_national
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.paper_presented_in_international
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.paper_presented_in_international
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.paper_presented_in_national?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.paper_presented_in_national?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.paper_presented_in_international
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.paper_presented_in_international
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.paper_presented_in_national?.total_score
                                  ? report?.research_contributions
                                    ?.paper_presented_in_national?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            g. Books Authored/ Edited book/ edited proceedings/
                            book chapter/ monographs (only with ISBN/ ISSN) (as first author, for more than one author, the score for other authors will be 50%)
                          </td>
                          <td>
                            <tr>
                              <td>Books - International Publisher</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Books - National Publisher</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Book Chapter - International Publisher</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Book Chapter - National Publisher</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.books_international_publisher?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.books_international_publisher
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.books_national_publisher?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.books_national_publisher?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.book_chapter_international_publisher
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.book_chapter_international_publisher
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.book_chapter_national_publisher?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.book_chapter_national_publisher
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.books_international_publisher
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.books_international_publisher
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.books_national_publisher?.total_activity
                                  ? report?.research_contributions
                                    ?.books_national_publisher?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.book_chapter_international_publisher
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.book_chapter_international_publisher
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.book_chapter_national_publisher
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.book_chapter_national_publisher
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.books_international_publisher
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.books_international_publisher
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.books_national_publisher?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.books_national_publisher
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.book_chapter_international_publisher
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.book_chapter_international_publisher
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.book_chapter_national_publisher
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.book_chapter_national_publisher
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.books_international_publisher?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.books_international_publisher
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.books_national_publisher?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.books_national_publisher?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.book_chapter_international_publisher
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.book_chapter_international_publisher
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.book_chapter_national_publisher?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.book_chapter_national_publisher
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.books_international_publisher?.total_score
                                  ? report?.research_contributions
                                    ?.books_international_publisher
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.books_national_publisher?.total_score
                                  ? report?.research_contributions
                                    ?.books_national_publisher?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.book_chapter_international_publisher
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.book_chapter_international_publisher
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.book_chapter_national_publisher?.total_score
                                  ? report?.research_contributions
                                    ?.book_chapter_national_publisher
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            h. Patents, copy right and technology transfer
                            agreements signed
                          </td>
                          <td>
                            <tr>
                              <td>Granted - International</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Granted - National</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Published - International</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Published - National</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_granted_international
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.patents_granted_international?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_granted
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.patents_granted?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_filed_international
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.patents_filed_international?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_filed
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.patents_filed?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_granted_international
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.patents_granted_international?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_granted
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.patents_granted?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_filed_international
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.patents_filed_international?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_filed
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.patents_filed?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_granted_international
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.patents_granted_international?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_granted
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.patents_granted?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_filed_international
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.patents_filed_international?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_filed
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.patents_filed?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_granted_international
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.patents_granted_international?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_granted
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.patents_granted?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_filed_international
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.patents_filed_international?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_filed
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.patents_filed?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_granted_international
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.patents_granted_international?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_granted
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.patents_granted?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_filed_international
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.patents_filed_international?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.patents_filed
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.patents_filed?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            i. Honors/ awards/ medals/ fellowships for
                            outstanding contributions
                          </td>
                          <td>
                            <tr>
                              <td>International</td>
                            </tr>
                            <br />
                            <tr>
                              <td>National</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.international_awards?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.international_awards?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.national_awards
                                  ?.total_activity_fixed
                                  ? report?.research_contributions
                                    ?.national_awards?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.international_awards?.total_activity
                                  ? report?.research_contributions
                                    ?.international_awards?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.national_awards
                                  ?.total_activity
                                  ? report?.research_contributions
                                    ?.national_awards?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.international_awards?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.international_awards?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.national_awards
                                  ?.per_actitity_score
                                  ? report?.research_contributions
                                    ?.national_awards?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.international_awards?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.international_awards?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.national_awards
                                  ?.total_score_fixed
                                  ? report?.research_contributions
                                    ?.national_awards?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.research_contributions
                                  ?.international_awards?.total_score
                                  ? report?.research_contributions
                                    ?.international_awards?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.research_contributions?.national_awards
                                  ?.total_score
                                  ? report?.research_contributions
                                    ?.national_awards?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">Total</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            {report?.research_contributions_total
                              ? report?.research_contributions_total
                              : "-"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div ref={table4Ref}>
                    <h5 className="centertext my-5">INSTITUTIONAL DEVELOPMENT</h5>
                    <table className="tablereport table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">Topic</th>
                          <th scope="col">Criteria</th>
                          <th scope="col">Target Fixed</th>
                          <th scope="col">Target Achieved</th>
                          <th scope="col">Score/Item</th>
                          <th scope="col">Score Fixed</th>
                          <th scope="col">Score Achieved</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="tablewidth">
                            a. Administrative contributions (subject to the
                            conduct of atleast two meetings in 6 months)
                          </td>
                          <td>
                            <tr>
                              <td>HOD/ In charge/ Chairman of the Committee</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Member of Committee</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.administrative_contributions_hod_of_the_committee
                                  ?.total_activity_fixed
                                  ? report?.institutional_development
                                    ?.administrative_contributions_hod_of_the_committee
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.administrative_contributions_member_of_the_committee
                                  ?.total_activity_fixed
                                  ? report?.institutional_development
                                    ?.administrative_contributions_member_of_the_committee
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.administrative_contributions_hod_of_the_committee
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.administrative_contributions_hod_of_the_committee
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.administrative_contributions_member_of_the_committee
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.administrative_contributions_member_of_the_committee
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.administrative_contributions_hod_of_the_committee
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.administrative_contributions_hod_of_the_committee
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.administrative_contributions_member_of_the_committee
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.administrative_contributions_member_of_the_committee
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.administrative_contributions_hod_of_the_committee
                                  ?.total_score_fixed
                                  ? report?.institutional_development
                                    ?.administrative_contributions_hod_of_the_committee
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.administrative_contributions_member_of_the_committee
                                  ?.total_score_fixed
                                  ? report?.institutional_development
                                    ?.administrative_contributions_member_of_the_committee
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.administrative_contributions_hod_of_the_committee
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.administrative_contributions_hod_of_the_committee
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.administrative_contributions_member_of_the_committee
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.administrative_contributions_member_of_the_committee
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            b. Infrastructure developed with internal/
                            external funding for improvement in science and
                            technology
                          </td>
                          <td>
                            <tr>
                              <td>Internal Funding more than 10 lakhs</td>
                            </tr>
                            <br />
                            <tr>
                              <td>External Funding upto 5 lakhs</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.infrastructure_development_internal_funding_upto_10_lakhs
                                  ?.total_activity_fixed
                                  ? report?.institutional_development
                                    ?.infrastructure_development_internal_funding_upto_10_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.infrastructure_development_external_funding_upto_5_lakhs
                                  ?.total_activity_fixed
                                  ? report?.institutional_development
                                    ?.infrastructure_development_external_funding_upto_5_lakhs
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.infrastructure_development_internal_funding_upto_10_lakhs
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.infrastructure_development_internal_funding_upto_10_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.infrastructure_development_external_funding_upto_5_lakhs
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.infrastructure_development_external_funding_upto_5_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.infrastructure_development_internal_funding_upto_10_lakhs
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.infrastructure_development_internal_funding_upto_10_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.infrastructure_development_external_funding_upto_5_lakhs
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.infrastructure_development_external_funding_upto_5_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.infrastructure_development_internal_funding_upto_10_lakhs
                                  ?.total_score_fixed
                                  ? report?.institutional_development
                                    ?.infrastructure_development_internal_funding_upto_10_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.infrastructure_development_external_funding_upto_5_lakhs
                                  ?.total_score_fixed
                                  ? report?.institutional_development
                                    ?.infrastructure_development_external_funding_upto_5_lakhs
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.infrastructure_development_internal_funding_upto_10_lakhs
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.infrastructure_development_internal_funding_upto_10_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.infrastructure_development_external_funding_upto_5_lakhs
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.infrastructure_development_external_funding_upto_5_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        {/* <tr>
                          <td className="tablewidth">
                            c. Revenue generated through Training Programmes as
                            Co-ordinator/ Other Avenues
                          </td>
                          <td>
                            <tr>
                              <td>&lt; 3 lakhs</td>
                            </tr>
                            <br />
                            <tr>
                              <td>3 - 5 lakhs</td>
                            </tr>
                            <br />
                            <tr>
                              <td>&gt; 5 lakhs</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.revenue_generated_through_training_programmes_lt_3_lakhs
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.revenue_generated_through_training_programmes_lt_3_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.revenue_generated_through_training_programmes_3_to_5_lakhs
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.revenue_generated_through_training_programmes_3_to_5_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.revenue_generated_through_training_programmes_gt_5_lakhs
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.revenue_generated_through_training_programmes_gt_5_lakhs
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.revenue_generated_through_training_programmes_lt_3_lakhs
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.revenue_generated_through_training_programmes_lt_3_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.revenue_generated_through_training_programmes_3_to_5_lakhs
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.revenue_generated_through_training_programmes_3_to_5_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.revenue_generated_through_training_programmes_gt_5_lakhs
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.revenue_generated_through_training_programmes_gt_5_lakhs
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.revenue_generated_through_training_programmes_lt_3_lakhs
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.revenue_generated_through_training_programmes_lt_3_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.revenue_generated_through_training_programmes_3_to_5_lakhs
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.revenue_generated_through_training_programmes_3_to_5_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.revenue_generated_through_training_programmes_gt_5_lakhs
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.revenue_generated_through_training_programmes_gt_5_lakhs
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr> */}
                        <tr>
                          <td className="tablewidth">
                            c. Research/ academic events (workshop/ conference/
                            seminar/ webinar/ programmes under national
                            initiatives) organized at national/ international
                            level as Coordinator (Score for the webinar will be
                            20% of workshop/ conference/ seminar; Score for the
                            Co-coordinator of workshop/ conference/ seminar will
                            be 50%)
                          </td>
                          <td>
                            <tr>
                              <td>
                                International/ Programmes under national
                                initiatives
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>National</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.research_or_academic_events_international
                                  ?.total_activity_fixed
                                  ? report?.institutional_development
                                    ?.research_or_academic_events_international
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.research_or_academic_events_national
                                  ?.total_activity_fixed
                                  ? report?.institutional_development
                                    ?.research_or_academic_events_national
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.research_or_academic_events_international
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.research_or_academic_events_international
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.research_or_academic_events_national
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.research_or_academic_events_national
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.research_or_academic_events_international
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.research_or_academic_events_international
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.research_or_academic_events_national
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.research_or_academic_events_national
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.research_or_academic_events_international
                                  ?.total_score_fixed
                                  ? report?.institutional_development
                                    ?.research_or_academic_events_international
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.research_or_academic_events_national
                                  ?.total_score_fixed
                                  ? report?.institutional_development
                                    ?.research_or_academic_events_national
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.research_or_academic_events_international
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.research_or_academic_events_international
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.research_or_academic_events_national
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.research_or_academic_events_national
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            d. Events conducted in collaboration with Industry
                          </td>
                          <td>
                            <tr>
                              <td>With Revenue Generation</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Without Revenue Generation</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.events_conducted_with_revenue_generation
                                  ?.total_activity_fixed
                                  ? report?.institutional_development
                                    ?.events_conducted_with_revenue_generation
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.events_conducted_without_revenue_generation
                                  ?.total_activity_fixed
                                  ? report?.institutional_development
                                    ?.events_conducted_without_revenue_generation
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.events_conducted_with_revenue_generation
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.events_conducted_with_revenue_generation
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.events_conducted_without_revenue_generation
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.events_conducted_without_revenue_generation
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.events_conducted_with_revenue_generation
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.events_conducted_with_revenue_generation
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.events_conducted_without_revenue_generation
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.events_conducted_without_revenue_generation
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.events_conducted_with_revenue_generation
                                  ?.total_score_fixed
                                  ? report?.institutional_development
                                    ?.events_conducted_with_revenue_generation
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.events_conducted_without_revenue_generation
                                  ?.total_score_fixed
                                  ? report?.institutional_development
                                    ?.events_conducted_without_revenue_generation
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.events_conducted_with_revenue_generation
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.events_conducted_with_revenue_generation
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.events_conducted_without_revenue_generation
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.events_conducted_without_revenue_generation
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            e. New initiatives implemented for the Institute
                            Development:
                          </td>
                          <td>
                            <tr>
                              <td>With Revenue Generation</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Without Revenue Generation</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.new_initiatives_implemented_with_revenue_generation
                                  ?.total_activity_fixed
                                  ? report?.institutional_development
                                    ?.new_initiatives_implemented_with_revenue_generation
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.new_initiatives_implemented_without_revenue_generation
                                  ?.total_activity_fixed
                                  ? report?.institutional_development
                                    ?.new_initiatives_implemented_without_revenue_generation
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.new_initiatives_implemented_with_revenue_generation
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.new_initiatives_implemented_with_revenue_generation
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.new_initiatives_implemented_without_revenue_generation
                                  ?.total_activity
                                  ? report?.institutional_development
                                    ?.new_initiatives_implemented_without_revenue_generation
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.new_initiatives_implemented_with_revenue_generation
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.new_initiatives_implemented_with_revenue_generation
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.new_initiatives_implemented_without_revenue_generation
                                  ?.per_actitity_score
                                  ? report?.institutional_development
                                    ?.new_initiatives_implemented_without_revenue_generation
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.new_initiatives_implemented_with_revenue_generation
                                  ?.total_score_fixed
                                  ? report?.institutional_development
                                    ?.new_initiatives_implemented_with_revenue_generation
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.new_initiatives_implemented_without_revenue_generation
                                  ?.total_score_fixed
                                  ? report?.institutional_development
                                    ?.new_initiatives_implemented_without_revenue_generation
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.new_initiatives_implemented_with_revenue_generation
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.new_initiatives_implemented_with_revenue_generation
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.institutional_development
                                  ?.new_initiatives_implemented_without_revenue_generation
                                  ?.total_score
                                  ? report?.institutional_development
                                    ?.new_initiatives_implemented_without_revenue_generation
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">Total</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>{report?.institutional_development_total}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div ref={table5Ref}>
                    <h5 className="centertext my-5">PROFESSIONAL CONTRIBUTIONS</h5>
                    <table className="tablereport table-bordered my-5">
                      <thead>
                        <tr>
                          <th scope="col">Topic</th>
                          <th scope="col">Criteria</th>
                          <th scope="col">Target Fixed</th>
                          <th scope="col">Target Achieved</th>
                          <th scope="col">Score/Item</th>
                          <th scope="col">Score Fixed</th>
                          <th scope="col">Score Achieved</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="tablewidth">
                            a. Resource person in Training Programmes/ Workshops
                            (External)
                          </td>
                          <td>
                            <tr>
                              <td>For 12 hours</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.resource_person_in_training_programmes
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.resource_person_in_training_programmes
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.resource_person_in_training_programmes
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.resource_person_in_training_programmes
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.resource_person_in_training_programmes
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.resource_person_in_training_programmes
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.resource_person_in_training_programmes
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.resource_person_in_training_programmes
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.resource_person_in_training_programmes
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.resource_person_in_training_programmes
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            b. Training programmes attended
                          </td>
                          <td>
                            <tr>
                              <td>International</td>
                            </tr>
                            <br />
                            <tr>
                              <td>National</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.training_programmes_attended_international
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.training_programmes_attended_international
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.training_programmes_attended_national
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.training_programmes_attended_national
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.training_programmes_attended_international
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.training_programmes_attended_international
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.training_programmes_attended_national
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.training_programmes_attended_national
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.training_programmes_attended_international
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.training_programmes_attended_international
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.training_programmes_attended_national
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.training_programmes_attended_national
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.training_programmes_attended_international
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.training_programmes_attended_international
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.training_programmes_attended_national
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.training_programmes_attended_national
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.training_programmes_attended_international
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.training_programmes_attended_international
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.training_programmes_attended_national
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.training_programmes_attended_national
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            c. Participation and academic contributions in the
                            area of your academic and professional expertise at
                            International/ National/ State Level
                          </td>
                          <td>
                            <tr>
                              <td>International</td>
                            </tr>
                            <br />
                            <tr>
                              <td>National</td>
                            </tr>
                            <br />
                            <tr>
                              <td>State</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_international
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_international
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_national
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_national
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_state
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_state
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_international
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_international
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_national
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_national
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_state
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_state
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_international
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_international
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_national
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_national
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_state
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_state
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_international
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_international
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_national
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_national
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_state
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_state
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_international
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_international
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_national
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_national
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_academic_contributions_state
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.participation_and_academic_contributions_state
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            d. Overseas visited for Academic Events/ Plenary
                            Lectures/ Invited Talks/ Part of Delegation/ Others
                          </td>
                          <td>
                            <tr>
                              <td>
                                academic events/ plenary lectures/ invited
                                talks/
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>Part of delegation</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.overseas_visited_for_academic_events
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.overseas_visited_for_academic_events
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.overseas_visited_for_part_of_delegation
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.overseas_visited_for_part_of_delegation
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.overseas_visited_for_academic_events
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.overseas_visited_for_academic_events
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.overseas_visited_for_part_of_delegation
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.overseas_visited_for_part_of_delegation
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.overseas_visited_for_academic_events
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.overseas_visited_for_academic_events
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.overseas_visited_for_part_of_delegation
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.overseas_visited_for_part_of_delegation
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.overseas_visited_for_academic_events
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.overseas_visited_for_academic_events
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.overseas_visited_for_part_of_delegation
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.overseas_visited_for_part_of_delegation
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.overseas_visited_for_academic_events
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.overseas_visited_for_academic_events
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.overseas_visited_for_part_of_delegation
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.overseas_visited_for_part_of_delegation
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            e. Participation and contributions in the area of
                            your academic and professional expertise
                          </td>
                          <td>
                            <tr>
                              <td>PG Examiner</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Doctoral Committee member</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Ph.D. Examiner</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_pg_examiner
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_pg_examiner
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_doctoral_committee
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_doctoral_committee
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_phd_examiner
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_phd_examiner
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_pg_examiner
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_pg_examiner
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_doctoral_committee
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_doctoral_committee
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_phd_examiner
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_phd_examiner
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_pg_examiner
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_pg_examiner
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_doctoral_committee
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_doctoral_committee
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_phd_examiner
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_phd_examiner
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_pg_examiner
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_pg_examiner
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_doctoral_committee
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_doctoral_committee
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_phd_examiner
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_phd_examiner
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_pg_examiner
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_pg_examiner
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_doctoral_committee
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_doctoral_committee
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.participation_and_contributions_in_phd_examiner
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.participation_and_contributions_in_phd_examiner
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            f. Editor-in-Chief/ Editorial Board Member/ Peer
                            Reviewer/ Others
                          </td>
                          <td>
                            <tr>
                              <td>Editor-in-chief (SCI)</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Editor-in-chief (Scopus)</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Editorial board member (SCI)</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Editorial board member (Scopus)</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Peer reviewer (SCI)</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Peer reviewer (Scopus)</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editor_in_cheif_sci?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.editor_in_cheif_sci?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editor_in_cheif_scopus?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.editor_in_cheif_scopus?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editorial_board_member_sci?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.editorial_board_member_sci?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editorial_board_member_scopus?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.editorial_board_member_scopus
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.peer_reviewer_sci?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.peer_reviewer_sci?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.peer_reviewer_scopus?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.peer_reviewer_scopus?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editor_in_cheif_sci?.total_activity
                                  ? report?.professional_contributions
                                    ?.editor_in_cheif_sci?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editor_in_cheif_scopus?.total_activity
                                  ? report?.professional_contributions
                                    ?.editor_in_cheif_scopus?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editorial_board_member_sci?.total_activity
                                  ? report?.professional_contributions
                                    ?.editorial_board_member_sci
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editorial_board_member_scopus
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.editorial_board_member_scopus
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.peer_reviewer_sci?.total_activity
                                  ? report?.professional_contributions
                                    ?.peer_reviewer_sci?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.peer_reviewer_scopus?.total_activity
                                  ? report?.professional_contributions
                                    ?.peer_reviewer_scopus?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editor_in_cheif_sci?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.editor_in_cheif_sci?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editor_in_cheif_scopus?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.editor_in_cheif_scopus
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editorial_board_member_sci
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.editorial_board_member_sci
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editorial_board_member_scopus
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.editorial_board_member_scopus
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.peer_reviewer_sci?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.peer_reviewer_sci?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.peer_reviewer_scopus?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.peer_reviewer_scopus?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editor_in_cheif_sci?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.editor_in_cheif_sci?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editor_in_cheif_scopus?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.editor_in_cheif_scopus?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editorial_board_member_sci?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.editorial_board_member_sci?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editorial_board_member_scopus?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.editorial_board_member_scopus
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.peer_reviewer_sci?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.peer_reviewer_sci?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.peer_reviewer_scopus?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.peer_reviewer_scopus?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editor_in_cheif_sci?.total_score
                                  ? report?.professional_contributions
                                    ?.editor_in_cheif_sci?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editor_in_cheif_scopus?.total_score
                                  ? report?.professional_contributions
                                    ?.editor_in_cheif_scopus?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editorial_board_member_sci?.total_score
                                  ? report?.professional_contributions
                                    ?.editorial_board_member_sci?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.editorial_board_member_scopus?.total_score
                                  ? report?.professional_contributions
                                    ?.editorial_board_member_scopus
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.peer_reviewer_sci?.total_score
                                  ? report?.professional_contributions
                                    ?.peer_reviewer_sci?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.peer_reviewer_scopus?.total_score
                                  ? report?.professional_contributions
                                    ?.peer_reviewer_scopus?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            g. National/ International academic assignment for
                            more than 1 year (Full-time)
                          </td>
                          <td>
                            <tr>
                              <td>International</td>
                            </tr>
                            <br />
                            <tr>
                              <td>National</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.international_academic_assignment
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.international_academic_assignment
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.national_academic_assignment?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.national_academic_assignment
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.international_academic_assignment
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.international_academic_assignment
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.national_academic_assignment?.total_activity
                                  ? report?.professional_contributions
                                    ?.national_academic_assignment
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.international_academic_assignment
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.international_academic_assignment
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.national_academic_assignment
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.national_academic_assignment
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.international_academic_assignment
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.international_academic_assignment
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.national_academic_assignment?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.national_academic_assignment
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.international_academic_assignment
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.international_academic_assignment
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions
                                  ?.national_academic_assignment?.total_score
                                  ? report?.professional_contributions
                                    ?.national_academic_assignment
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">
                            h. Fellow/ Life Member/ Member of Professional
                            Bodies/ Societies
                          </td>
                          <td>
                            <tr>
                              <td>Fellow</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Life member</td>
                            </tr>
                            <br />
                            <tr>
                              <td>Member</td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions?.fellow
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions?.fellow
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions?.life_member
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions
                                    ?.life_member?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions?.member
                                  ?.total_activity_fixed
                                  ? report?.professional_contributions?.member
                                    ?.total_activity_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions?.fellow
                                  ?.total_activity
                                  ? report?.professional_contributions?.fellow
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions?.life_member
                                  ?.total_activity
                                  ? report?.professional_contributions
                                    ?.life_member?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions?.member
                                  ?.total_activity
                                  ? report?.professional_contributions?.member
                                    ?.total_activity
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions?.fellow
                                  ?.per_actitity_score
                                  ? report?.professional_contributions?.fellow
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions?.life_member
                                  ?.per_actitity_score
                                  ? report?.professional_contributions
                                    ?.life_member?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions?.member
                                  ?.per_actitity_score
                                  ? report?.professional_contributions?.member
                                    ?.per_actitity_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions?.fellow
                                  ?.total_score_fixed
                                  ? report?.professional_contributions?.fellow
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions?.life_member
                                  ?.total_score_fixed
                                  ? report?.professional_contributions
                                    ?.life_member?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions?.member
                                  ?.total_score_fixed
                                  ? report?.professional_contributions?.member
                                    ?.total_score_fixed
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                          <td>
                            <tr>
                              <td>
                                {report?.professional_contributions?.fellow
                                  ?.total_score
                                  ? report?.professional_contributions?.fellow
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions?.life_member
                                  ?.total_score
                                  ? report?.professional_contributions
                                    ?.life_member?.total_score
                                  : "-"}
                              </td>
                            </tr>
                            <br />
                            <tr>
                              <td>
                                {report?.professional_contributions?.member
                                  ?.total_score
                                  ? report?.professional_contributions?.member
                                    ?.total_score
                                  : "-"}
                              </td>
                            </tr>
                          </td>
                        </tr>
                        <tr>
                          <td className="tablewidth">Total</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>{report?.professional_contributions_total}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div ref={table6Ref}>
                    <h5 className="centertext mt-5">OVERALL SCORE</h5>
                    <div className="row">
                      <div className="col-lg-8 mx-auto ms-auto">
                        <table className="tablereport table-bordered my-4">
                          <thead>
                            <tr>
                              <th scope="col"></th>
                              <th scope="col">Total Score Fixed</th>
                              <th scope="col">Total Score Achieved</th>
                              <th scope="col">Weightage %</th>
                              <th scope="col">Final Score Fixed</th>
                              <th scope="col">Final Score Achieved</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Academic Contributions</td>

                              <td>
                                {report?.academic_contributions_total_fixed
                                  ? report?.academic_contributions_total_fixed
                                  : "-"}
                              </td>
                              <td>
                                {report?.academic_contributions_total
                                  ? report?.academic_contributions_total
                                  : "-"}
                              </td>
                              <td>60</td>

                              <td>
                                {report?.academic_contributions_final_score_fixed
                                  ? report?.academic_contributions_final_score_fixed
                                  : "-"}
                              </td>
                              <td>
                                {report?.academic_contributions_final_score
                                  ? report?.academic_contributions_final_score
                                  : "-"}
                              </td>
                            </tr>
                            <tr>
                              <td>Research Contributions</td>
                              <td>
                                {report?.research_contributions_total_fixed
                                  ? report?.research_contributions_total_fixed
                                  : "-"}
                              </td>
                              <td>
                                {report?.research_contributions_total
                                  ? report?.research_contributions_total
                                  : "-"}
                              </td>
                              <td>20</td>
                              <td>
                                {report?.research_contributions_final_score_fixed
                                  ? report?.research_contributions_final_score_fixed
                                  : "-"}
                              </td>
                              <td>
                                {report?.research_contributions_final_score
                                  ? report?.research_contributions_final_score
                                  : "-"}
                              </td>
                            </tr>
                            <tr>
                              <td>Institutional Development</td>
                              <td>
                                {report?.institutional_development_total_fixed
                                  ? report?.institutional_development_total_fixed
                                  : "-"}
                              </td>

                              <td>
                                {report?.institutional_development_total
                                  ? report?.institutional_development_total
                                  : "-"}
                              </td>
                              <td>15</td>
                              <td>
                                {report?.institutional_development_final_score_fixed
                                  ? report?.institutional_development_final_score_fixed
                                  : "-"}
                              </td>

                              <td>
                                {report?.institutional_development_final_score
                                  ? report?.institutional_development_final_score
                                  : "-"}
                              </td>
                            </tr>
                            <tr>
                              <td>Professional Contributions</td>
                              <td>
                                {report?.professional_contributions_total_fixed
                                  ? report?.professional_contributions_total_fixed
                                  : "-"}
                              </td>

                              <td>
                                {report?.professional_contributions_total
                                  ? report?.professional_contributions_total
                                  : "-"}
                              </td>
                              <td>5</td>
                              <td>
                                {report?.professional_contributions_final_score_fixed
                                  ? report?.professional_contributions_final_score_fixed
                                  : "-"}
                              </td>
                              <td>
                                {report?.professional_contributions_final_score
                                  ? report?.professional_contributions_final_score
                                  : "-"}
                              </td>
                            </tr>
                            <tr>
                              <td>Grand Total</td>
                              <td></td>
                              <td></td>
                              <td>100 %</td>
                              <td>{report?.final_score_fixed}</td>
                              <td>{formattedScore}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="centertext">
                    <button className="requestbtn" onClick={handleDownloadPdf}>
                      Generate PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DirectorScoreReportGenerate;
